import { put, takeEvery } from 'redux-saga/effects'
import { push } from 'connected-react-router'
// @ts-ignore
import { MICROACTIONS_PATH } from 'app/constants/navLinks'

import { createOrganization, updateOrganization } from '../actions'

export function* handleSaveOrgSuccess() {
  yield put(push(`${MICROACTIONS_PATH}/organizations`))
}

export default function* takeEverySaveOrganizationSuccess() {
  yield takeEvery([createOrganization.success.toString(), updateOrganization.success.toString()], handleSaveOrgSuccess)
}
